import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  EditButton,
  ShowButton,
  TopToolbar,
  SearchInput,
  DeleteWithConfirmButton,
} from 'react-admin';
import { Card, Typography, Box } from '@mui/material';
import { Add as AddIcon, Person as PersonIcon } from '@mui/icons-material';
import CustomCreateButton from '@/components/CustomCreateButton';

const UserListActions = () => (
  <TopToolbar>
    <CustomCreateButton
      variant='contained'
      label='Crear Usuario'
      icon={<AddIcon />}
      sx={{
        height: '40px',
        backgroundColor: 'primary.main',
        '&:hover': {
          backgroundColor: 'primary.dark',
        },
      }}
    />
  </TopToolbar>
);

// Filtros para la búsqueda
const userFilters = [
  <SearchInput
    key='search'
    source='q'
    placeholder='Buscar usuarios...'
    alwaysOn
    size='small'
    sx={{ 
      minWidth: 200,
      mb: 0.5
    }}
  />,
];

export const UsersList: React.FC = () => (
  <Card elevation={1} sx={{ m: 2, p: 2 }}>
    <Box sx={{ p: 3, pt: 2, pb: 2.5, borderBottom: 1, borderColor: 'divider' }}>
      <Typography
        variant='h5'
        component='h1'
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <PersonIcon color='primary' />
        Gestión de Usuarios
      </Typography>
    </Box>
    <List
      title={false}
      sort={{ field: 'userName', order: 'ASC' }}
      perPage={25}
      filters={userFilters}
      actions={<UserListActions />}
      sx={{ '& .RaList-main': { mt: 0 } }}
    >
      <Datagrid
        rowClick='show'
        sx={{ '& .RaDatagrid-headerCell': { fontWeight: 'bold' } }}
      >
        <TextField source='id' label='ID' />
        <TextField source='userName' label='Usuario' />
        <TextField source='fullName' label='Nombre Completo' />
        <EmailField source='email' label='Email' />
        <TextField source='phoneNumber' label='Teléfono' />
        <ShowButton label={false}/>
        <EditButton label={false}/>
        <DeleteWithConfirmButton
          confirmTitle='Confirmar eliminación'
          confirmContent={`¿Seguro que quieres eliminar al usuario ? Esta acción no se puede deshacer.`}
          mutationMode='pessimistic'
          label={false}
        />
      </Datagrid>
    </List>
  </Card>
);
